import type {MilestonePickerMilestoneItem} from '@github-ui/item-picker-milestone'
import type {RecordSourceProxy} from 'relay-runtime'

export type IssueUpdateArgs = {
  milestoneId: string | undefined
  clearMilestone: boolean | undefined
}

export function updateIssuesById(store: RecordSourceProxy, ids: string[], issueUpdateArgs: IssueUpdateArgs) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) continue

    if (issueUpdateArgs.clearMilestone) {
      issue.setValue(null, 'milestone')
    } else if (issueUpdateArgs.milestoneId) {
      const milestone = store.get(issueUpdateArgs.milestoneId)
      if (milestone) {
        issue.setLinkedRecord(milestone, 'milestone')
      }
    }
  }
}

export function addMilestoneToStore(
  store: RecordSourceProxy,
  milestoneId: string,
  milestone: MilestonePickerMilestoneItem,
) {
  // Create an optimistic Milestone record with the provided fields so
  // issues can link to it immediately, as long as it does not yet exist.
  // If it does exist, still copy the values over, as they could be stale.
  const record = store.get(milestoneId) || store.create(milestoneId, 'Milestone')

  const propertiesToSet: MilestonePickerMilestoneItem = {
    id: milestoneId,
    title: milestone.title,
    closed: milestone.closed,
    dueOn: milestone.dueOn,
    progressPercentage: milestone.progressPercentage,
    url: milestone.url,
    closedAt: milestone.closedAt,
  }

  for (const [key, value] of Object.entries(propertiesToSet)) {
    if (value != null) {
      record.setValue(value, key)
    }
  }
}
